import React from 'react';
import { Moon, Star, ArrowRight } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center px-6 py-20 overflow-hidden" data-id="element-40">
      {/* Ambient Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-amber-warm/5 rounded-full blur-[120px] pointer-events-none" data-id="element-41" />

      <div className="max-w-2xl w-full mx-auto relative z-10 flex flex-col items-center text-center space-y-12" data-id="element-42">
        {/* Timestamp Hook */}
        <FadeIn delay={0.2} className="flex flex-col items-center space-y-4" data-id="element-43">
          <div className="inline-flex items-center space-x-2 px-4 py-1.5 rounded-full bg-night-400/50 border border-night-300 backdrop-blur-sm" data-id="element-44">
            <Moon className="w-4 h-4 text-amber-warm fill-amber-warm/20" data-id="element-45" />
            <span className="font-mono text-amber-warm text-lg tracking-widest animate-pulse" data-id="element-46">
              02:17 AM
            </span>
          </div>
        </FadeIn>

        {/* Narrative Lead */}
        <FadeIn delay={0.4} className="space-y-6 text-lg md:text-xl text-night-50/90 leading-relaxed font-light" data-id="element-47">
          <p data-id="element-48">Tu bebé se despierta otra vez.</p>
          <p data-id="element-49">
            Tú ni siquiera piensas. Tu cuerpo se levanta antes que tu mente,
            porque ya aprendiste que si esperas, el llanto sube… y tú no tienes
            reservas para eso.
          </p>
          <p className="text-night-100 italic text-base md:text-lg" data-id="element-50">
            Y en ese punto, da igual cuántos videos viste, cuántos consejos
            guardaste, o cuántas veces te dijeron "es una fase".
          </p>
        </FadeIn>

        {/* Main Headline */}
        <FadeIn delay={0.6} className="space-y-6" data-id="element-51">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-night-50 leading-tight" data-id="element-52">
            No necesitas más tips.
            <br data-id="element-53" />
            <span className="text-amber-warm" data-id="element-54">
              Necesitas un guion para las 2:17am.
            </span>
          </h1>
          <p className="text-night-100 text-lg max-w-lg mx-auto" data-id="element-55">
            Cuando estás agotada, no necesitas inspiración. Necesitas decisiones
            pre-hechas.
          </p>
        </FadeIn>

        {/* Product Image */}
        <FadeIn delay={0.8} className="relative w-full max-w-md mx-auto my-8 group cursor-pointer" onClick={scrollToOffer} data-id="element-56">
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-warm/20 to-night-300/20 rounded-2xl blur opacity-75 group-hover:opacity-100 transition duration-1000" data-id="element-57"></div>
          <img src="https://cdn.magicpatterns.com/uploads/opEzsKnsWWVDans3HshWAD/DORMIR5HRSSEGUIDASBEBES4-6M.png" alt="Dormir 5 Horas Seguidas Guide on Tablet" className="relative rounded-2xl shadow-2xl shadow-black/50 border border-night-300/50 transform transition-transform duration-500 hover:scale-[1.02]" data-id="element-58" />
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={1.0} data-id="element-59">
          <a href="https://doctormomstudio.com/cart/52252112945333:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', {
            value: 29,
            currency: 'USD',
            content_name: 'Dormir 5 Horas Seguidas'
          });
        }} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-night-500 bg-amber-warm rounded-full overflow-hidden transition-all duration-300 hover:bg-amber-glow hover:shadow-[0_0_20px_rgba(232,168,56,0.4)] focus:outline-none focus:ring-2 focus:ring-amber-warm focus:ring-offset-2 focus:ring-offset-night-500" data-id="element-60">
            <span className="relative z-10 flex items-center" data-id="element-61">
              Quiero el Reset de 14 Noches
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-62" />
            </span>
          </a>
          <p className="mt-4 text-sm text-night-100 flex items-center justify-center gap-2" data-id="element-63">
            <Star className="w-3 h-3 text-amber-warm fill-amber-warm" data-id="element-64" />
            <span data-id="element-65">Para bebés de 4–6 meses</span>
            <Star className="w-3 h-3 text-amber-warm fill-amber-warm" data-id="element-66" />
          </p>
        </FadeIn>
      </div>

      {/* Decorative Stars */}
      <div className="absolute top-1/4 left-10 text-night-300/30 animate-pulse delay-700" data-id="element-67">
        <Star className="w-4 h-4" data-id="element-68" />
      </div>
      <div className="absolute bottom-1/3 right-12 text-night-300/30 animate-pulse delay-1000" data-id="element-69">
        <Star className="w-6 h-6" data-id="element-70" />
      </div>
    </section>;
}